module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "song"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "song-wrapper"
  }, [_c('div', {
    staticClass: "bg",
    style: ({
      backgroundImage: ("url(" + (_vm.song.pic_radio) + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "prev",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "song"
  }, [_c('div', {
    staticClass: "song-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.song.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("\n            " + _vm._s(_vm.song.author) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "cdLrc-wrapper",
    class: {
      mask: !_vm.toggle
    },
    on: {
      "click": function($event) {
        _vm.toggleFn()
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggle),
      expression: "toggle"
    }]
  }, [_c('cd', {
    attrs: {
      "play": _vm.playState,
      "songDetail": _vm.song
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lrc-paragraph"
  }, [_vm._v(_vm._s(this.lrcParagraph))])], 1)]), _vm._v(" "), _c('lrc', {
    attrs: {
      "show": !_vm.toggle,
      "lrc": _vm.lrc.lrcMap,
      "offset": _vm.lrcOffset,
      "currentTime": _vm.currentTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "barMargin"
  }, [_c('progressbar')], 1), _vm._v(" "), _c('div', {
    staticClass: "song-controller-wrapper"
  }, [_c('songConteroller', {
    attrs: {
      "song": _vm.song,
      "play": _vm.playState
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7386a93c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/view/song.vue
// module id = 210
// module chunks = 1